// Use a static glyphs URL with known fonts. This URL contains:
//
// * Arial Unicode MS Regular
// * Arial Unicode MS Bold
//
// Then, ensure that all layer styles utilize fonts from this set of glyphs.

export const FONT_NAMES = {
  regular: ['Arial Unicode MS Regular'],
  bold: ['Arial Unicode MS Bold'],
};

export const WILDFIRE_SOURCE_ID = 'wildfire-events';
export const PLACE_LABELS_SOURCE_ID = 'place-labels';
export const LOCATIONS_SOURCE_ID = 'locations';
export const HAZARDS_SOURCE_ID = 'hazards';

// Use these for <Layer beforeId={...}>
export const ON_TOP_OF_EVERYTHING_LAYER_ID = undefined;
export const BELOW_STREETS_LAYER_ID = 'wd-inject-layers-below';
export const BELOW_RADAR_LAYER_ID = 'wd-inject-radar-below';
export const OVERLAY_ICONS_BEFORE_ID = 'wd-inject-overlay-icons-below';
export const LOCATION_ICONS_LAYER_ID = 'location-icons';
export const LOCATION_LABELS_LAYER_ID = 'location-labels';
export const HAZARD_ICONS_LAYER_ID = 'hazard-icons';
